import * as React from 'react';
import './migrationSection.module.scss';
import { Header } from './base';
import Step1 from './images/step1.png';
import Step2 from './images/step2.png';
import Step3 from './images/step3.png';
import Step4 from './images/step4.png';
import Step5 from './images/step5.png';
import Step1Sp from './images/step1-sp.png';
import Step2Sp from './images/step2-sp.png';
import Step3Sp from './images/step3-sp.png';
import Step4Sp from './images/step4-sp.png';
import Step5Sp from './images/step5-sp.png';
import StepArrowImg from './images/step-arrow.png';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

const StepArrow = () => <img styleName="arrow" src={StepArrowImg} />;
const Step = observer(({ src, mobSrc }) => (
  <img styleName="step" src={GlobalStatesV3.viewport.isMobile ? mobSrc : src} />
));

export const MigrationSection = () => (
  <div styleName="section">
    <Header>移行の方法</Header>
    <div styleName="steps">
      <div styleName="step-header">4ステップで完了！</div>
      <Step src={Step1} mobSrc={Step1Sp} />
      <StepArrow />
      <Step src={Step2} mobSrc={Step2Sp} />
      <StepArrow />
      <Step src={Step3} mobSrc={Step3Sp} />
      <StepArrow />
      <Step src={Step4} mobSrc={Step4Sp} />
      <StepArrow />
      <Step src={Step5} mobSrc={Step5Sp} />
      <div styleName="footer">
        ※無料期間が終了後選択したプランが自動更新されます
        <br />
        ※更新前に退会すると、自動更新は起こりません。
        <br />
        ※途中で退会しても、適用した無料分はご利用できます
      </div>
    </div>
  </div>
);
